<template>
  <div>
  </div>
</template>

<script>
  export default {
    name: "features",
    mounted() {
      this.$router.replace({ name: this.pub.routeNameLists.HomePage, params: { initiativeGuide: 'yes' }})
    }
  }
</script>

<style scoped>

</style>
